import { GetDtrStatisticInput, Statistic } from '@/models/gen/graphql';

import { GetDtrStatisticDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';
import { handleError } from '@/utils/custom';

type GetDtrStatisticGraphApiResponse = GraphApiResponse<typeof GetDtrStatisticDocument>;

const title = 'Get Drive Time Statistics';

const getDtrStatisticResponseSelector = (res: GetDtrStatisticGraphApiResponse): Statistic[] => res?.getDtrStatistic?.output as Statistic[];

const [_runGetDtrStatistic, runRefetchGetDtrStatistic] = graphApi(GetDtrStatisticDocument, {
  onError: (res: GetDtrStatisticGraphApiResponse): void => handleError(res, { notification: { title } }),
});

export const getDtrStatistic = async (input: GetDtrStatisticInput): Promise<Statistic[]> => {
  const res = await runRefetchGetDtrStatistic({ input });

  return getDtrStatisticResponseSelector(res);
};

export const useGetDtrStatistic = createGraphApiHook(getDtrStatistic);
